export default "__VITE_ASSET__c753b457__"